var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.689,
    height: 120.713,
    viewBox: "0 0 128.689 120.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-study-lamp-1372396",
    transform: "translate(-10.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_516",
    "data-name": "Caminho 516",
    d: "M254.632,79.839a32.246,32.246,0,0,0-45.612,0l-.112.112-4.756-3.934h0a11.286,11.286,0,0,0-14.946.484L149.35,114.117a14.107,14.107,0,1,0-.806,22.572l31.537,32.246H165.732a11.092,11.092,0,0,0,0,22.169H220.55a11.093,11.093,0,0,0,0-22.169H184.613l-33.651-34.342a14.028,14.028,0,0,0,.645-18.187l39.823-37.552h0a8.061,8.061,0,0,1,10.625-.355l4.708,3.87a32.247,32.247,0,0,0,2.257,43.08,1.613,1.613,0,0,0,2.274,0l11.834-11.834.565.565h0a15.526,15.526,0,0,0,21.895-21.943l-.565-.565,9.545-9.545h0a1.612,1.612,0,0,0,.064-2.29ZM228.417,179.994a7.868,7.868,0,0,1-7.852,7.852H165.747a7.867,7.867,0,0,1,0-15.719h54.818a7.868,7.868,0,0,1,7.852,7.867ZM140.547,136.01a10.9,10.9,0,1,1,7.691-3.193,10.887,10.887,0,0,1-7.691,3.193Zm102.815-41.5a12.3,12.3,0,0,1-17.38,17.38l-.565-.5L242.8,93.946Zm-33.245,27.474a29.021,29.021,0,0,1,41.065-40.968Z",
    transform: "translate(-115.827 -70.39)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTable);
export default __webpack_public_path__ + "static/media/light-table.7a7596a9f0b7b45deb2928df3ac8b3cf.svg";
export { ForwardRef as ReactComponent };